import { Brands } from "../interfaces/enums";

export const transformBrandToUserReadable = (brand: string | undefined): string => {
  if (!brand) {
    return "N/A";
  }
  switch (brand) {
    case "biz-collection":
      return Brands.BizCollection;
    case "biz-corporates":
      return Brands.BizCorporates;
    case "syzmik":
      return Brands.Syzmik;
    case "syzmik-boots":
      return Brands.SyzmikBoots;
    case "good-mates":
      return Brands.GoodMates;
    case "direct-group":
      return "Direct Group";
    case "inaura":
      return Brands.Inaura;
    default:
      return brand;
  }
};
